import styled from "styled-components";

export const Wrapper = styled.div`
  position: absolute;
  left: 24px;
  bottom: 24px;
  min-height: 144px;
  .container {
    background-color: var(--black-300);

    border-radius: 4px;

    padding: 20px;

    z-index: 999;

    width: 330px;

    .header {
      flex-direction: row;
      align-items: center;
      justify-content: space-between;

      .headerBody {
        flex-direction: row;
        align-items: center;
      }
    }
  }

  .title {
    font-size: 1rem;
    font-family: DM Sans;
    font-weight: 500;

    padding: 0;

    max-width: 250px;
    white-space: nowrap;
    overflow: hidden;
    padding-right: 1.2rem;
    text-overflow: ellipsis;

    &.withIcon {
      max-width: 195px;
    }

    &.skeleton {
      margin-bottom: 0.3rem;
    }
  }

  .coordText {
    font-family: Inter;
    color: var(--primary);
    font-weight: 500;
  }

  .closeButton {
    background-color: var(--black-400);
    padding: 0rem;
    width: 30px;
    height: 30px;

    border-radius: 100%;

    margin-left: 0.5rem;

    display: flex;
    align-items: center;
    justify-content: center;

    transition: background 0.4s;

    &:hover {
      background-color: var(--black-100);
    }

    img {
      width: 20px;
      height: 20px;
    }
  }

  .buttonContainer {
    margin: 0.8rem 0rem 0rem 0rem;
    padding-bottom: 0.5rem;

    border-bottom: 1px solid rgba(56, 56, 56, 0.64);

    &.withoutDivider {
      border-bottom: 0;
    }

    &.skeleton div {
      margin-bottom: 0.5rem;

      &:last-child {
        margin-bottom: 0;
      }
    }

    button {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;

      background-color: var(--black-400);
      color: var(--white);

      font-size: 0.8rem;
      font-family: Inter;
      border-radius: 4px;

      padding: 0.55rem;

      margin-bottom: 0.5rem;

      transition: background 0.4s;

      &:hover {
        background-color: var(--black-100);
      }
    }
  }

  .iconContainer {
    svg {
      width: 3rem;
      height: 3rem;

      padding: 0.7rem;

      background: var(--black-100);

      border-radius: 4px;

      margin-right: 0.5rem;

      path {
        stroke: var(--grey-100);
      }
    }
  }
`;
